import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center px-1"},[_vm._t("top",function(){return [(_vm.title && _vm.title.trim().length > 0)?[_c(VIcon,{staticStyle:{"font-size":"20px"},attrs:{"left":""}},[_vm._v("mdi-format-list-bulleted")]),_c('span',{staticClass:"subtitle-1 font-weight-medium"},[_vm._v(_vm._s(_vm.title))])]:_vm._e(),_c(VSpacer),_vm._t("top-right")]},{"rows":_vm.itensFiltrados})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }